module.exports = __webpack_public_path__ + "goegl_official/img/favicon.33d7a87.png";